<template>
  <p v-if="spell.reactionTo" class="footnote reactionTo">
    <Icon name="fa6-solid:asterisk" /> - ({{ spell.reactionTo }})
  </p>
  <p v-if="spell.materialComponent" class="footnote materialComponent">
    <Icon name="fa6-solid:asterisk" /> - ({{ spell.materialComponent }})
  </p>
  <p v-if="lists?.length" class="spell-lists">
    <SpellTag v-for="list in lists" :key="list" :tag="list" />
  </p>
</template>

<script setup lang="ts">
import type { ParsedContent } from '@nuxt/content'
import type { SpellPage } from '../content/SpellListing.vue'
import { resolveSpellLists } from '~/assets/spells/spellData';

const props = defineProps<{
  spell: SpellPage | ParsedContent
}>()

const lists = computed(() => resolveSpellLists(props.spell.title ?? ''))

</script>
